import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import responseHandler from './responseHandler';
import getEnvelopeBody from './getEnvelopeBody';
import { appendQueryParameters } from './location';
import parseJSON from '../json/parseJson';

var rnoContent = function rnoContent(method) {
  return /^(?:GET|HEAD)$/i.test(method);
};

export default function fetchAdaptor(options) {
  var method = options.method || 'GET';
  var hasContent = !rnoContent(method);
  var url = options.url || window.location.href;
  var requestInit;

  if (options.envelope) {
    url = appendQueryParameters(url, {
      envelope: 'request'
    });
    requestInit = {
      method: 'POST',
      headers: {},
      credentials: 'same-origin',
      body: getEnvelopeBody(method, options.headers || {}, options.data)
    };
  } else {
    requestInit = {
      method: method,
      headers: options.headers || {},
      credentials: 'same-origin'
    };

    if (options.data) {
      if (!hasContent) {
        url = appendQueryParameters(url, options.data);
      } else {
        requestInit.body = JSON.stringify(options.data);
        requestInit.headers = _objectSpread(_objectSpread({}, requestInit.headers), {}, {
          'Content-Type': 'application/json'
        });
      }
    }
  }

  return fetch(url, requestInit).then(function (res) {
    return Promise.all([res, res.text()]);
  }).then(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        res = _ref2[0],
        body = _ref2[1];

    return responseHandler(res.status, parseJSON(body));
  });
}
//# sourceMappingURL=fetch.js.map